"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CloudinaryImage_1 = require("../CloudinaryImage");
const Image = ({ data, theme = {}, ...rest }) => {
    if (!data) {
        return null;
    }
    if (data.cloudinary) {
        return (React.createElement(CloudinaryImage_1.default, Object.assign({}, rest, { className: theme.root, data: data.cloudinary, fluid: data.fluid })));
    }
    return React.createElement("img", Object.assign({ className: theme.root, src: data.src }, rest));
};
exports.default = Image;
//# sourceMappingURL=index.js.map